import { DropdownOption } from '@elxjs/ui'

export function formatAsBrDateTime(dateString: string): string {
  let date = new Date(dateString)

  if (isNaN(date.getTime())) {
    const [d, t, tz] = dateString.split(' ')
    const [day, month, year] = d.split('/')

    const iso = `${year}-${month}-${day}T${t}${tz ?? ''}`
    date = new Date(iso)
  }

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${day}/${month}/${year}\n${hours}h${minutes}`
}

export function parseBrOrIsoDate(dateString: string | null | undefined): Date | null {
  if (!dateString) return null

  const trimmed = dateString.trim()
  const brMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(trimmed)

  if (brMatch) {
    const day = Number(brMatch[1])
    const month = Number(brMatch[2])
    const year = Number(brMatch[3])
    const parsed = new Date(year, month - 1, day)

    const isValid =
      !isNaN(parsed.getTime()) &&
      parsed.getFullYear() === year &&
      parsed.getMonth() === month - 1 &&
      parsed.getDate() === day

    if (isValid) return parsed
  }

  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed)

  if (isoDateMatch) {
    const year = Number(isoDateMatch[1])
    const month = Number(isoDateMatch[2])
    const day = Number(isoDateMatch[3])
    const parsed = new Date(year, month - 1, day)

    const isValid =
      !isNaN(parsed.getTime()) &&
      parsed.getFullYear() === year &&
      parsed.getMonth() === month - 1 &&
      parsed.getDate() === day

    if (isValid) return parsed
  }

  const fallback = new Date(trimmed)

  if (!isNaN(fallback.getTime())) return fallback
  return null
}

export function formatAsBrDate(value: string | null | undefined): string {
  if (!value) return ''

  const parsed = parseBrOrIsoDate(value)
  if (!parsed) return value

  const day = String(parsed.getDate()).padStart(2, '0')
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const year = parsed.getFullYear()

  return `${day}/${month}/${year}`
}

export function formatAsIsoDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function getDateRange(option: DropdownOption) {
  const startDate = new Date()
  const endDate = new Date()

  switch (option.value) {
    case 1:
      startDate.setDate(startDate.getDate() - 7)
      break
    case 2:
      startDate.setDate(startDate.getDate() - 30)
      break
    case 3:
      startDate.setMonth(startDate.getMonth() - 6)
      break
    case 4:
      startDate.setFullYear(startDate.getFullYear() - 1)
      break
    case 5:
      startDate.setFullYear(startDate.getFullYear() - 10)
      endDate.setFullYear(endDate.getFullYear() - 1)
      break
  }

  return {
    startDate: formatAsIsoDate(startDate),
    endDate: formatAsIsoDate(endDate),
  }
}
